// extracted by mini-css-extract-plugin
export default {"container":"common_container__JJwH3","desc":"common_desc__5a6D8","form":"common_form__ywQYv"};